export default __webpack_public_path__ + "static/media/24.1bf377c4.jpg";